import styled from '@xstyled/styled-components'

export const MoteCardControlsRoot = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '2',
  width: 'full',
  maxWidth: '234px'
})
